import { defineMessages } from 'react-intl';

export const PANNING_CONTROLS_MESSAGES = defineMessages({
  panLeft: {
    id: '1HXxdMWF9JUS/EWC',
    defaultMessage: 'Pan left',
    description: 'Applies pan to the left',
  },
  panRight: {
    id: '+8N30Kx6cXgWSja4',
    defaultMessage: 'Pan right',
    description: 'Applies pan to the right',
  },
});
